import { Notyf } from 'notyf';


const _notify = new Notyf({
  duration: 10000,
  position: { x: 'right', y: 'top' },
  types: [
    {
      type: 'error',
      background: '#CB3247',
      dismissible: true
    },
    {
      type: 'success',
      background: '#00813F',
      dismissible: true
    },
  ]
});

export const notify = () => {
  return _notify;
};
